import { SxStyle, SxStyleFunc } from '@aibees/shared/theme';
import { AdvanceTableColumn } from '../../types';

interface RowCollapse {
  stickyCollapsed: boolean;
  stickyRowsHeight: number;
}

export const row: SxStyleFunc<boolean | undefined> = (isSelected) => ({
  background: isSelected
    ? (p) => p.palette.primary[50]
    : (p) => p.palette.common.white,
  '&:hover': {
    '& .hover-border': {
      visibility: 'visible',
      backgroundColor: (p) => p.palette.primary[200],
    },
  },
});

export const hoverBorder: SxStyleFunc<boolean | undefined> = (isSelected) => ({
  position: 'absolute',
  height: '102%',
  top: 0,
  left: 0,
  bottom: 0,
  width: '5px',
  visibility: isSelected ? 'visible' : 'hidden',
  backgroundColor: isSelected
    ? (p) => p.palette.primary[500]
    : (p) => p.palette.primary[200],
});

export const rowCollaps: SxStyleFunc<RowCollapse> = ({
  stickyCollapsed,
  stickyRowsHeight,
}) => ({
  zIndex: stickyCollapsed ? 999 : 1,
  transform: stickyCollapsed
    ? `translateY(-${stickyRowsHeight - 30}px)`
    : `translateY(0px)`,
});

export const expandButton: SxStyle = {
  '&.MuiButtonBase-root:hover': {
    bgcolor: 'transparent',
  },
};

export const cellBase: SxStyleFunc<{
  col: AdvanceTableColumn<any>;
  isSelected: boolean;
  cellSx?: SxStyle;
}> = ({ col, isSelected, cellSx }) => ({
  fontSize: (p) => p.typography.body2.fontSize,
  overflow: 'hidden',
  whiteSpace: 'pre-wrap',
  width: col.width ?? col.minWidth ?? '100%',
  maxWidth: col.width ?? col.minWidth,
  minWidth: col.minWidth,
  textAlign: col.align,
  boxShadow: col.boxShadow,
  borderRightColor: (p) => `${p.palette.grey[300]} !important;`,
  background: (p) =>
    isSelected ? p.palette.primary[50] : p.palette.common.white,
  ...cellSx,
});

export const getStickyCellSx: SxStyleFunc<{
  isSelected: boolean;
  width: string;
}> = ({ isSelected, width }) => ({
  position: 'sticky',
  left: width,
  background: (p) =>
    isSelected ? p.palette.grey[200] : p.palette.common.white,
  zIndex: 9,
  borderRightColor: (p) => `${p.palette.grey[300]} !important;`,
});

export const getStickyCheckboxSx: SxStyleFunc<boolean> = (
  isSelected: boolean
) => ({
  position: 'sticky',
  left: 0,
  zIndex: 9,
  background: (p) =>
    isSelected ? p.palette.primary[50] : p.palette.common.white,
});
